module.exports = __webpack_public_path__ + "static/media/banner-new-bg.eee3a771.jpg";